<script>
import MyNotifyDialog from "@/components/MyNotifyDialog.vue";
import BackIcon from "@/components/BackIcon.vue";
import {areaCheckMixin} from "@/utils/myMixins";
import {getApplyListByVisitCode, visitorSearchByIdCardNo} from "@/api/visit-api";
import {myPath} from "@/utils/constant";
import {usual_visitor_sign_mixin} from "@/helper/usual_visitor_mixin";

export default {
  name: "IdCardCome",
  components: {MyNotifyDialog, BackIcon},
  mixins: [areaCheckMixin, usual_visitor_sign_mixin],

  mounted() {
    this.setupAreaInfo()
    window.addEventListener('idCardCheckEvent', this.handleInputFromJava)
  },
  destroyed() {
    window.removeEventListener('idCardCheckEvent', this.handleInputFromJava)
  },
  // get visitorAgreement from store
  computed: {
    agreement() {
      return this.$store.state.signEnterAgreement
    },
  },
  data() {
    return {
      title: "身份证签到",

      inputCode: "",
      haveRead: false,

      applyList: [],
      showApplyList: false,

      step: 1,
      visitor: null, // 人证核验成功后的访客信息

      searchVisitorList: [], // 身份证号查询到的访客列表
      selectVisitorDialogVisible: false,
      selectVisitor: null, // 最终选择的访客信息
      agreementTitle: "签到须知",

    }
  }, // end data

  methods: {

    handleInputFromJava(event) {
      const param = JSON.parse(event.detail)
      if (param.isSuccess) {
        this.$message.success("人证比对成功")
        const name = param.name
        const idCardNo = param.idCardNo
        const score = param.score
        this.doOnIdCardCheckSuccess(name, idCardNo, score)
      } else {
        this.doOnIdCardCheckFalse()
      }
    },

    doOnIdCardCheckSuccess(name, idCardNo, score) {
      this.visitor = {name: name, idCardNo: idCardNo, score: score}

      visitorSearchByIdCardNo(idCardNo).then(({data}) => {
        console.log("visitorSearchByIdCardNo", data)
        if (data.code === 200 && data.data.length > 0) {
          this.searchVisitorList = data.data
          if (this.searchVisitorList.length === 1) {
            this.doOnGetVisitor(this.searchVisitorList[0])
          } else {
            this.selectVisitorDialogVisible = true
          }
        } else {
          this.$message.error("未找到对应的访客信息")
          this.logE("VisitCodeCome visitorSearchByIdCardNo false", data.code, data.msg)
        }
      }).catch((err) => {
        this.logE("VisitCodeCome visitorSearchByIdCardNo err", err)
        this.showNetErrMsg()
      })

    },

    doOnGetVisitor(visitor) {
      if (this.checkIsVisitorUsual(visitor)) {


        let areaId = this.$store.state.areaId
        let deviceId = this.$store.state.deviceId
        let remark = ""
        let imageBase64 = this.JavaBaseInfo.getBase64Image("enterPhoto")
        let icCompareResult = "pass"
        let icCompareScore = this.visitor.score
        this.doUsualSignEnter(visitor, deviceId, areaId, remark, imageBase64, icCompareResult, icCompareScore)
        return
      }
      this.selectVisitorDialogVisible = false
      this.selectVisitor = visitor

      getApplyListByVisitCode(visitor.code).then(({data}) => {
        console.log("getApplyListByVisitCode", data)
        this.applyList = []
        if (data.code === 200) {
          let applyList = data.data
          if (applyList.length > 0) {
            applyList.forEach(item => {
              this.applyList.push({
                myVisitorName: item.visitor.name,
                myEmployeeName: item.employee.name,
                myBeginTime: item.beginDate + " " + item.beginTime,
                myEndTime: item.endDate + " " + item.endTime,
                myStatus: item.state,
                data: item
              })
            })
            this.showApplyList = true;

           if (this.applyList.length === 1 && this.applyList[0].myStatus === "PASS") {
              this.doSignEnter(this.applyList[0].data)
            }
          } else {
            this.$message.warning("查询失败，未能找到对应的申请记录")
          }
        } else {
          this.showNetErrMsg(data.code)
          this.logE("VisitCodeCome getApplyListByVisitCode false", data.code, data.msg)
        }
      }).catch((err) => {
        this.logE("VisitCodeCome getApplyListByVisitCode err", err)
        this.showNetErrMsg()
      })

    },

    doOnIdCardCheckFalse() {
      this.notify = {
        title: "身份证核验失败",
        show: true,
        success: false,
        msg: "身份证核验失败"
      }
    },

    onNotifyDialogClose() {
      this.notify.show = false
      if (this.visitor === null) {
        this.$router.back()
        this.$router.back()
      }
    },


    onCancelClick() {
      this.$router.back()
    },

    onEnsureClick() {
      if (!this.haveRead && this.agreement.valid) {
        this.$message.warning("请先阅读并同意" + this.agreementTitle)
        return
      }

      let baiduFaceKey = this.JavaBaseInfo.getBaseInfo("Setting.BaiduFaceKey")
      let initStatus = this.JavaBaseInfo.getFaceSdkInitStatus()
      let initStatusMsg = this.JavaBaseInfo.getFaceSdkErrorMsg()
      if (initStatus !== 0) {
        let msgNoKey = "没有设置算法key,无法人证核验"
        let msgHasKey = "秘钥激活失败，原因：" + initStatusMsg + "，请确认当前key是否正确，以及输入后是否重启app，如果确认key失效，请输入新key并重启app"
        let msg = baiduFaceKey ? msgHasKey : msgNoKey
        this.$alert(msg, '提示', {
          confirmButtonText: '确定',
        }).then(() => {
          this.$router.back()
        }).catch(() => {
          this.$router.back()
        });
      } else {
        try {
          this.IdCardCheck.startCheckIdCard()
        } catch (e) {
          console.log("startCheckIdCard error")
        }
      }
    },

    jumpToPrintPage(signResult) {
      let applyInfo = signResult.apply
      let visitor = signResult.visitor
      let reasonObj = applyInfo.forms.find(item => item.name === "reason")
      let reason = reasonObj ? reasonObj.value : ""
      let carObj = applyInfo.forms.find(item => item.name === "carNumber")
      let car = carObj ? carObj.value : ""
      let printData = {
        visitorName: visitor.name,
        visitorCode: signResult.pinCode,
        visitorCompany: visitor.company,
        visitorReason: reason,
        employName: applyInfo.employee.name,
        employDepartment: applyInfo.employee.departmentName,
        visitorCar: car,
        visitorTime: applyInfo.beginDate + " " + applyInfo.beginTime,
        visitorGoods: "",
        idCardNo: visitor.ic,
        visitorPhone: visitor.tel,
      }
      this.$router.push({name: myPath.printPage, params: {printData: printData}})
    },

    async doSignEnter(applyInfo) {

      let signPhotoBase64 = this.JavaBaseInfo.getBase64Image("enterPhoto")
      let idCardCheckInfo = {photoKey: signPhotoBase64, score: this.visitor.score}

      this.$router.push({
        name: myPath.signEnter,
        params: {
          applyInfo: applyInfo,
          visitorInfo: this.selectVisitor,
          idCardCheckInfo: idCardCheckInfo
        }
      })

    },


    checkIdCard() {
      // test
      this.doOnIdCardCheckSuccess("哈哈", "123456")
    }
  }, // end methods

  filters: {
    tableDateFilter(value) {
      switch (value) {
        case 'PASS':
          return "审批通过"
        case 'REJECT':
          return "审批拒绝"
        case 'CANCEL':
          return "审批撤销"
        case 'PROCESS ':
        case 'NONE ':
        default:
          return "审批中"
      }
    }
  }

}
</script>

<template>
  <div>

    <el-dialog :visible.sync="selectVisitorDialogVisible" title="选择访客信息" width="90%" center>
      <div class="dialog-container">
        <el-table :data="searchVisitorList" height="500">
          <el-table-column prop="name" label="访客姓名"></el-table-column>
          <el-table-column prop="ic" label="身份证号"></el-table-column>
          <el-table-column prop="tel" label="手机号"></el-table-column>
          <el-table-column label="操作" width="120">
            <template v-slot="scope">
              <el-button @click="doOnGetVisitor(scope.row)" type="success">
                选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!--    签到成功失败弹框-->
    <my-notify-dialog :show="notify.show" :success="notify.success" :msg="notify.msg" :title="notify.title"
                      :reprint="notify.reprint" :rePrintData="notify.rePrintData"
                      @dialogClose="onNotifyDialogClose"></my-notify-dialog>


    <el-container class="common-page-box">
      <el-header class="header-box">
        <div class="empty"></div>
        <div class="title">{{ title }}</div>
        <BackIcon></BackIcon>
      </el-header>
      <el-main class="main-content" style="margin-bottom: 15px">
        <div class="main-half main-left">
          <template v-if="!showApplyList">
            <div class="search-box">
              <el-button style="width: 500px; font-size: 35px" @click="onEnsureClick" type="primary">开始人证核验
              </el-button>
            </div>
            <div class="agreement-box">
              <div v-if="agreement.valid ">
                <el-checkbox size="mini" v-model="haveRead">请阅读并同意《{{ agreementTitle }}》</el-checkbox>
              </div>
            </div>
          </template>
          <el-table v-else :data="applyList" border style="width: 90%;">
            <el-table-column prop="myVisitorName" label="访客"></el-table-column>
            <el-table-column prop="myEmployeeName" label="受访者"></el-table-column>
            <el-table-column prop="myBeginTime" label="开始时间"></el-table-column>
            <el-table-column prop="myEndTime" label="结束时间"></el-table-column>
            <el-table-column prop="myStatus" label="状态">
              <template v-slot="scope">
                <el-tag>{{ scope.row.myStatus | tableDateFilter }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                <el-button :disabled="scope.row.myStatus !== 'PASS'" @click="doSignEnter(scope.row.data)"
                           type="success">
                  预约详情
                </el-button>
              </template>
            </el-table-column>

          </el-table>

        </div>

        <div class="main-half" v-if="agreement.valid">
          <div class="agreement-title">{{ agreementTitle }}</div>
          <div class="agreement-text" v-html="agreement.content"></div>
        </div>

      </el-main>
    </el-container>
  </div>

</template>


<style scoped lang="less">

.dialog-container {
  display: flex;
  flex-direction: column; /* 设置为纵向布局 */
  max-height: 500px;
  overflow-y: auto; /* 设置纵向滚动条自动显示 */
}

.dialog-sign {
  display: flex;
  height: 45vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.dialog-main {
  .dialog-content {
    height: 50vh;
    overflow: auto;
  }

  .dialog-footer {
    padding: 0;
  }
}
</style>
